import { AbstractControl, ValidatorFn } from '@angular/forms';

export function matchPasswordValidator(pswdControl: AbstractControl): ValidatorFn {
  return (confirmPswdControl: AbstractControl): { [key: string]: any } => {
    const pswd = typeof pswdControl.value === 'string' ? pswdControl.value : '';
    const confirmPswd = typeof confirmPswdControl.value === 'string' ? confirmPswdControl.value : '';
    return pswd === confirmPswd ? null : { matchpassword: { valid: false } };
  };
}



// WEBPACK FOOTER //
// ./src/app/global/match-password.validator.ts